import React, { useRef } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import EraseEdit from './EraseEdit';

export default function Erase(props: any) {
  const { branchStoreId, closeModal } = props;
  const ref = useRef<any>(undefined);
  const handleOk = (e: any) => {
    closeModal(true);
  };
  //表头
  const columnsHead = [

    {
      title: '分店',
      dataIndex: 'branchStore',
      render: (text: any) => (text ? text.branchStoreName : "")
    },
    {
      title: '规则',
      dataIndex: 'eraseSpecificationName',
    //   render: (text: any) => (text ? text.floor : "")
    },
    {
      title: '排序',
      dataIndex: 'sortBy',
    },
  ];
  const columns = columnsheadId
    .concat(columnsHead as []);
  let extendProps: WUExtendPropsType = {
    ...props,
    titleName: '抹零规则',
    apiId: 'erase',
    showStates: true,
    showDefault:true,
    sendPageData: { branchStoreId },
    extendIdName: "branchStoreId",
    columns,
    pagination: true,
    EditComponent: EraseEdit,
  };
  return (
    <div>
      <AntDraggableModal
        open={true}
        okText='确定'
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={handleOk}
        closable={false}
        maskClosable={false}
        width={800}>
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
      </AntDraggableModal>
    </div>
  )
}
